import script from "./BioIntelligentApplication.vue?vue&type=script&setup=true&lang=js"
export * from "./BioIntelligentApplication.vue?vue&type=script&setup=true&lang=js"

import "./BioIntelligentApplication.vue?vue&type=style&index=0&id=04452f65&lang=scss"

const __exports__ = script;

export default __exports__